/* eslint-disable react/no-multi-comp */
import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Dialog, { DialogTitle } from 'material-ui/Dialog';
import { Button, DialogActions, DialogContent } from 'material-ui';
import { translate } from 'react-i18next';
import { registerPopUpWidget } from './PopUpDialogController';
import { getCMSWidgetClassByObject, getLabels } from './cmsLib';

const styles = {
    root: {
        backgroundColor: 'white',
        color: 'var(--primary-color)'
    },
    dialogTitle: {
        fontWeight: '300',
        fontSize: '28px'
    },
    dialogPaper: {
        minHeight: '90vh',
        maxHeight: '90vh',
    },
};
/**
 * PopUpDialog para el CMS.
 *
 * @author Luciano Bustos
 *
 */
class PopUpDialog extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            widget: null,
            titleName: '',
        };
        registerPopUpWidget('cmsPopUpDialog', this);
    }

    displayContent = (data) => {
        let widgetData = { ...data };
        let title = getLabels(widgetData.labels, 'header.text');
        //remove labels header
        this.setState({
            titleName: title,
            widget: widgetData
        }, () => {
            this.props.onOpen();
        });
    }

    handleClose = () => {
        this.props.onClose(this.state);
    };

    handleCancel = () => {
        this.showBodyScrollBars();
        this.props.onClose(null);
    };

    showBodyScrollBars = () => {
        // dialog has side-effect that prevents body from scrolling if this not checked
        //document.querySelector('body').style.overflow = 'visible';
    };

    handleEnter = () => {
        this.hideBodyScrollBars();
    };

    hideBodyScrollBars() {
        // dialog has a side-effect if this not checked
        //document.querySelector('body').style.overflow = 'hidden';
    }


    render() {
        const { classes, onClose, t, ...other } = this.props;
        const ImageWidgetClazz = getCMSWidgetClassByObject({ type: 'PopUpImageWidget' });
        return (
            <Dialog
                onClose={this.handleClose}
                onEnter={this.handleEnter}
                aria-labelledby="simple-dialog-title"
                classes={{ paper: classes.dialogPaper }}
                PaperProps={{
                    classes: {
                        root: classes.root
                    }
                }
                }
                {...other}>
                <DialogTitle disableTypography={true} id="pop-dialog-title"
                    className={classes.dialogTitle}>
                    <span dangerouslySetInnerHTML={{ __html: this.state.titleName }}></span>
                </DialogTitle>
                <DialogContent>
                    <ImageWidgetClazz widget={this.state.widget} />
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.handleCancel} color="primary" variant="raised">{t('COMMON.CLOSE')}</Button>
                </DialogActions>
            </Dialog>
        );
    }
}

PopUpDialog.propTypes = {
    classes: PropTypes.object.isRequired,
    onClose: PropTypes.func,
    onOpen: PropTypes.func,
};
export default translate('translations')(withStyles(styles)(PopUpDialog));


// WEBPACK FOOTER //
// ./src/cms/PopUpDialog.js